var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.148,
    height: 18.225,
    viewBox: "0 0 12.148 18.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#237bdf;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-307.051 -363.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M313.14,363a6.085,6.085,0,0,1,6.057,6.166,7.722,7.722,0,0,1-1.079,3.446c-1.326,2.5-2.676,4.995-4.017,7.491a2.34,2.34,0,0,1-.271.484c-.213.234-.431.548-.7.621-.391.106-.545-.3-.7-.6-1.326-2.466-2.663-4.926-3.973-7.4a22.456,22.456,0,0,1-1.011-2.2A6,6,0,0,1,313.14,363Zm-.024,16.312c.107-.176.161-.259.208-.346,1.176-2.181,2.373-4.35,3.514-6.549a14.959,14.959,0,0,0,.971-2.435,3.566,3.566,0,0,0,.13-1.491,4.721,4.721,0,0,0-4.141-4.216c-3.849-.552-6.384,3.281-5.268,6.062.307.765.6,1.541.981,2.27,1,1.913,2.038,3.8,3.061,5.7C312.737,378.62,312.9,378.927,313.116,379.316Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M341.487,394.257a3.241,3.241,0,1,1-3.2-3.257A3.26,3.26,0,0,1,341.487,394.257Zm-3.26,2.008a2.025,2.025,0,1,0-2.006-2.044A2.024,2.024,0,0,0,338.227,396.265Z",
    transform: "translate(-25.121 -25.158)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b1dd8300906f0b1fbe54ae549cd4b909.svg";
export { ForwardRef as ReactComponent };